import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getExtStyles } from "@air/component-file-extension-preview";
import { tailwindMerge } from "@air/tailwind-variants";
import { ASSET_STATE_TEXT, EXT_PREVIEW_BOX } from "~/constants/testIDs";
import { ClipIconSize } from "~/types/clip-icon-size";
/**
 * This component is used to to differentiate files by icon and color based on the file's extension.
 * Styling is different for icons on the modal, in file table view, and file gallery view.
 * Icons are grey when processing a new upload.
 */ const FileExtensionPreview = (param)=>{
    let { ext, color = "color", size = "small", text, className } = param;
    const sizeMap = {
        small: {
            icon: ClipIconSize.small,
            font: 8,
            textMarginTop: 2
        },
        mediumSmall: {
            icon: ClipIconSize.mediumSmall,
            font: 10,
            textMarginTop: 2
        },
        medium: {
            icon: ClipIconSize.medium,
            font: 12,
            textMarginTop: 10
        }
    };
    const { iconName, iconComponent: IconComponent, iconColor, modalIconColor } = getExtStyles(ext);
    const colorMap = {
        gray: "var(--colors-grey9)",
        color: iconColor,
        default: modalIconColor
    };
    const extIconColor = "currentColor";
    return /*#__PURE__*/ _jsxs("div", {
        className: tailwindMerge("flex flex-col items-center", className),
        "data-testid": EXT_PREVIEW_BOX,
        style: {
            color: colorMap[color]
        },
        children: [
            /*#__PURE__*/ _jsx(IconComponent, {
                "data-testid": iconName,
                style: {
                    width: sizeMap[size].icon,
                    color: extIconColor
                }
            }),
            !!text && /*#__PURE__*/ _jsx("div", {
                className: "text-center text-14 font-bold uppercase",
                "data-testid": ASSET_STATE_TEXT,
                style: {
                    marginTop: sizeMap[size].textMarginTop,
                    // using fontSize because size 8 font (uppercased is a visual 10) is not in our TextVariant system
                    fontSize: sizeMap[size].font
                },
                children: text
            })
        ]
    });
};
export default FileExtensionPreview;
